import React from "react";
import { Button } from "antd";
import "./PendingApplicationsBanner.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClockFour } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CollabsState } from "redux-context/collabs";

const PendingApplicationsBanner: React.FC = () => {
  const navigate = useNavigate();
  const { pending } = useSelector(
    (state: CollabsState) => state.collabs?.numbers
  );
  const onClickReview = () => {
    navigate("/applications?status=pending");
  };

  if (pending === 0) {
    return null;
  }

  return (
    <div className="pending-applications-banner">
      <div className="pending-applications-banner__icon">
        <span className="pending-applications-banner__icon-bg">
          <FontAwesomeIcon icon={faClockFour} color="#F4A940" />
        </span>
      </div>
      <div className="pending-applications-banner__info">
        <div className="pending-applications-banner__title">
          Pending Applications
        </div>
        <div className="pending-applications-banner__desc">
          Review and approve influencer applications across campaigns
        </div>
      </div>
      <div className="pending-applications-banner__count-section">
        <div className="pending-applications-banner__count">{pending}</div>
        <div className="pending-applications-banner__label">
          Awaiting Review
        </div>
      </div>
      <Button type="primary" className="label-strong" onClick={onClickReview}>
        Review Applications
      </Button>
    </div>
  );
};

export default PendingApplicationsBanner;
